const TABS = [
  { id: 'dashboard', label: 'Сводка' },
  { id: 'status', label: 'Версии' },
  { id: 'urgent', label: 'Срочное' },
  { id: 'map', label: 'Карта' },
  { id: 'broadcast', label: 'Рассылка' },
  { id: 'find', label: 'Найти' },
  { id: 'rules', label: 'Правила' },
];

/** Cap on wide screens; narrow screens use 100% with equal fr columns. */
const TAB_SLOT_REM = 4.75;

/** Active/idle differ only by color — never by size/weight/shadow/padding. */
function tabButtonClass(isActive) {
  return [
    'flex h-8 w-full min-w-0 items-center justify-center truncate rounded-md px-0.5 text-center text-[12px] font-medium leading-none transition-colors sm:px-1 sm:text-[13px]',
    isActive
      ? 'bg-white text-slate-900 dark:bg-slate-800 dark:text-white'
      : 'text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200',
  ].join(' ');
}

/** Equal slots; width follows container on narrow screens (no overflow crooks). */
export default function RisksSectionTabs({ activeTab = 'dashboard', onChange }) {
  const maxWidth = `calc(${TABS.length} * ${TAB_SLOT_REM}rem + ${(TABS.length - 1) * 0.125}rem + 0.25rem)`;

  return (
    <div className="w-full max-w-full min-w-0">
      <nav
        aria-label="Разделы рисков"
        className="grid w-full gap-0.5 rounded-xl border border-slate-300 bg-slate-100/80 p-0.5 dark:border-slate-700 dark:bg-slate-900/80"
        style={{
          maxWidth,
          gridTemplateColumns: `repeat(${TABS.length}, minmax(0, 1fr))`,
        }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange?.(tab.id)}
              className={tabButtonClass(isActive)}
            >
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
